import { render, staticRenderFns } from "./BaseInputMultiple.vue?vue&type=template&id=380ef98f&scoped=true&"
import script from "./BaseInputMultiple.vue?vue&type=script&lang=js&"
export * from "./BaseInputMultiple.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputMultiple.vue?vue&type=style&index=0&id=380ef98f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ef98f",
  null
  
)

export default component.exports